import classNames from 'classnames';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const Grid = ({
  noPad,
  noGap,
  className,
  children
}) => {
  const classes = classNames('grid', {
    'no-pad': noPad,
    'no-gap': noGap
  }, className);
  return /*#__PURE__*/_jsx("div", {
    className: classes,
    children: children
  });
};